export enum TypeOfPurchase {
  GP_CLASS_1 = 'GP_CLASS_1',
  GP_SOV = 'GP_SOV',
  NGP = 'NGP',
}
